import { useTranslation } from 'react-i18next';

import type { ButtonType, ComponentSize } from '../types';
import { NgTooltip } from '../NgTooltip';
import { NgButton } from './NgButton';

export type NgCopyButtonProps = {
  cssClass?: string;
  type?: ButtonType;
  outline?: boolean;
  size?: ComponentSize;
  valueToCopy?: string;
};

export function NgCopyButton({
  cssClass,
  type = 'link',
  outline,
  size = 'small',
  valueToCopy,
}: NgCopyButtonProps) {
  const { t } = useTranslation();

  const copyValueToClipboard = async () => {
    await navigator.clipboard.writeText(valueToCopy ?? '');
  };

  return (
    <NgTooltip text={t('CopyButtonConfirmationMessage')}>
      <NgButton
        type={type}
        outline={outline}
        size={size}
        icon="fal fa-copy"
        cssClass={cssClass}
        ariaLabel={t('CopyButtonTitle')}
        onClick={copyValueToClipboard}
      />
    </NgTooltip>
  );
}
